import useSessionStorage from './use-session-storage'

export const useRecentlyViewedProducts = () => {
  const [recentlyViewedProducts, addToRecentlyViewedProducts] = useSessionStorage(
    'recently-viewed-products',
    [],
  )

  return [recentlyViewedProducts, addToRecentlyViewedProducts]
}
